var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base-button",class:'base-button_' + _vm.buttonStyle + ' base-button_' + _vm.buttonSize,attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }